import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import React from "react";
import { useAppSelector } from "redux/hooks";

export default function RVSMWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  if (
    selectedAccount.isEnabled &&
    selectedAccount.userPermission.view
  ) {
    return <>{children}</>;
  }
  return <></>;
}
